import Fab from '@material-ui/core/Fab'

export default Fab
